import http from "../http-common";

class processFileService {
  download(payload) {
    return http.post("/process/downloadFile", payload);
  };

  process(payload) {
    return http.post("/process/processFile", payload);
  }

  processMultipleFile(payload) {
    return http.post("/process/processMultipleFile", payload);
  }

  processById(id) {
    return http.put(`/process/processFile/${id}`);
  }

  viewRawById(id) {
    return http.put(`/process/viewRaw/${id}`);
  }

  viewRawFile(payload) {
    return http.post(`/process/viewRawFile`, payload);
  }

  viewOriginalFileById(id) {
    return http.put(`/process/viewOriginalFile/${id}`);
  }

  viewOriginalFile(payload) {
    return http.post(`/process/viewOriginalFile`, payload);
  }

  uploadFiles(payload) {
    return http.post("/process/uploadFiles", payload);
  }

  uploadFileById(id) {
    return http.put(`/process/uploadFile/${id}`);
  }

  processSASFileById(id) {
    return http.put(`/process/processSASFile/${id}`);
  }
  
  cancelFileById(id) {
    return http.put(`/process/cancelFile/${id}`);
  }

  deleteFileById(id) {
    return http.put(`/process/deleteFile/${id}`);
  }

  getConversionList(id) {
    return http.get(`/process/getConversionList/${id}`);
  }


}

export default new processFileService();
